/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SummarySection } from "../../snapshots/types/SummarySection";
export const ResolutionSummaryConflicts = core.serialization
    .object({
    totalRemovedFromMain: core.serialization.number(),
})
    .extend(SummarySection);
